<template>
  <div class="columns is-multiline mt-20">
    <div class="column is-12">
      <div class="level">
        <div class="level-left">
          <p class="has-text-weight-bold is-size-14-px has-text-grid-1">
            {{$t('creerClient.labelPJ')}}
          </p>
        </div>
        <div class="level-right">
          <b-field class="file">
            <b-upload v-model="pjFiles" multiple @input="addPiecesJointe">
              <a class="button is-primary">
                <p class="is-size-14px has-text-weight-bold">
                  {{$t('creerClient.btnAjoutPJ')}}
                </p>
              </a>
            </b-upload>
          </b-field>
        </div>
      </div>
    </div>
    <div class="column card-contact ma-10"
      v-for="pj in piecesJointes"
      :key="pj.id">
      <div class="media media-align-center">
        <figure class="media-left">
          <p class="image">
            <img class="picto-file-mail" :src="getImgPictoFile(pj.nom)">
          </p>
        </figure>
        <div class="media-content">
          <div class="content width-file-name">
            <p class="is-size-14px has-text-weight-bold has-text-gird-1 mb-0 truncate-file-name">
              {{pj.nom}}
            </p>
            <p class="is-size-7 has-text-default">
              {{formatDatePj(pj)}} - {{bytesToSize(pj.size)}}
            </p>
          </div>
        </div>
        <div class="media-right">
          <b-dropdown
            position="is-bottom-left"
            aria-role="list">
            <a
              class="navbar-item"
              slot="trigger"
              role="button">
              <b-icon custom-class="icon-color" icon="dots-vertical"></b-icon>
            </a>
            <b-dropdown-item aria-role="listitem" @click="removePJ(pj.id)">
              {{$t('creerClient.suppPj')}}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </div>
    <div class="column card-contact ma-10" v-if="!piecesJointes.length">
      <div class="media media-align-center">
        <div class="media-content">
          <div class="content has-text-centered is-size-7">
            {{$t('creerClient.aucunPiece')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/modules/client-mutation-type';
import generePJ from '@/services/piecesJointes/genererPiecesJointes';
import { getImgPictoFile, bytesToSize } from '@/services/general/general';

const Client = createNamespacedHelpers('client');

export default {
  data () {
    return {
      pjFiles: [],
    };
  },
  computed: {
    ...Client.mapState({
      piecesJointes: 'piecesJointes',
    }),
  },
  methods: {
    ...Client.mapMutations({
      addPJ: types.SET_PJ,
      removePJ: types.REMOVE_PJ,
    }),
    async addPiecesJointe() {
      const piecesJointes = await generePJ(this.pjFiles.map(file => {
        return {file, placeType: ''};
      }));
      this.addPJ(piecesJointes);
      this.pjFiles = [];
    },
    getImgPictoFile(name) {
      const split = name.split('.');
      const type = split[split.length - 1];
      return getImgPictoFile(type);
    },
    formatDatePj(pj) {
      if (!pj || !pj.file || !pj.file.lastModifiedDate) return '';
      return moment(pj.file.lastModifiedDate).format('LL');
    },
    bytesToSize(size) {
      return bytesToSize(size);
    },
  },
}
</script>
